import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPackageDelivery"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H8V13.126C9.40561 13.4878 10.5122 14.5944 10.874 16H21V18H10.874C10.4299 19.7252 8.86384 21 7 21C4.79086 21 3 19.2091 3 17C3 15.1362 4.27477 13.5701 6 13.126V5H3V3ZM7 15C8.10457 15 9 15.8954 9 17C9 18.1046 8.10457 19 7 19C5.89543 19 5 18.1046 5 17C5 15.8954 5.89543 15 7 15Z" fill="currentColor"/><Path d="M14.5 4H10V14H21V4H16.5V9H14.5V4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageDelivery;
